var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1042",
    "data-name": "Group 1042",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.165,
    height: 22.165,
    viewBox: "0 0 22.165 22.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M0,0H22.165V22.165H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M10.312,2A8.312,8.312,0,1,1,2,10.312,8.315,8.315,0,0,1,10.312,2Zm0,14.776a6.465,6.465,0,1,0-6.465-6.465A6.463,6.463,0,0,0,10.312,16.776Zm7.836.066,2.613,2.612L19.454,20.76l-2.612-2.613,1.306-1.306Z",
    transform: "translate(-0.153 -0.153)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e9828fa66d2120884d8de354d057ecc7.svg";
export { ForwardRef as ReactComponent };